class DynamicFormRows {
    constructor(containerSelector, fieldConfigs, baseName, globalConfig = {}) {
        this.container = $(containerSelector);
        this.fieldConfigs = fieldConfigs;
        this.globalConfig = globalConfig;
        this.baseName = baseName;
        this.rowCount = 0;
        this.init();
    }

    init() {
        this.container.on('click', '.addRow', () => this.addRow());
        this.container.on('click', '.removeRow', (e) => this.removeRow(e));

        const enforceFirstEntry = this.globalConfig.hasOwnProperty('enforceFirstEntry') && this.globalConfig.enforceFirstEntry === true;
        const initiallyAddRows = this.globalConfig.hasOwnProperty('initiallyAddRows') ? this.globalConfig.initiallyAddRows : 0;

        if (enforceFirstEntry && initiallyAddRows < 1)
        {
            this.globalConfig.initiallyAddRows = 1;
        }

        if (
            !(this.globalConfig.preFilledData && Array.isArray(this.globalConfig.preFilledData)) &&
            this.globalConfig.hasOwnProperty('initiallyAddRows') && this.globalConfig.initiallyAddRows > 0
        )
        {
            for (let i = 0; i < this.globalConfig.initiallyAddRows; i++)
            {
                this.addRow();
            }
        }

        if (this.globalConfig.preFilledData && Array.isArray(this.globalConfig.preFilledData)) {
            this.globalConfig.preFilledData.forEach((rowData) => {
                this.addRow(rowData);
            });
        }

        this.setupFieldDependencies();
        this.triggerDependencyCheckForRow();
    }

    validateField(input) {
        const nameAttr = input.attr('name');
        const fieldNameMatch = nameAttr.match(/\[(\w+)\]$/);
        if (!fieldNameMatch) return true;

        const fieldName = fieldNameMatch[1];
        const fieldConfig = this.fieldConfigs.find(f => f.name === fieldName);
        if (!fieldConfig || !fieldConfig.validation) return true;

        const value = input.val();
        let isValid = true;
        let messages = []; // Use an array to collect messages
        let message = '';

        // Check for "required" validation
        if (fieldConfig.validation.required && !value) {
            isValid = false;
            //messages.push(fieldConfig.validation.requiredMessage);
            message = fieldConfig.validation.requiredMessage;
        }

        // Check for "pattern" validation
        if (fieldConfig.validation.pattern && !fieldConfig.validation.pattern.test(value)) {
            isValid = false;
            //messages.push(fieldConfig.validation.patternMessage);
            message = fieldConfig.validation.patternMessage;
        }

        // Update UI based on validation
        if (!isValid) {
            input.addClass('is-invalid');
            input.next('.invalid-feedback').remove();
            // Join all messages and display them
            //input.after(`<div class="invalid-feedback"><strong>${messages.join(' ')}</strong></div>`);
            input.after(`<div class="invalid-feedback"><strong>${message}</strong></div>`);
        } else {
            input.removeClass('is-invalid');
            input.next('.invalid-feedback').remove();
        }

        return isValid;
    }

    createInput(field, rowIndex) {
        let input;
        switch (field.type) {
            case 'select':
                input = $('<select class="form-control"></select>');
                field.options.forEach(option => {
                    input.append(`<option value="${option.value}">${option.text}</option>`);
                });
                break;
            case 'checkbox':
                input = $(`<input type="checkbox" class="form-check-input">`);
                if (field.value) input.prop('checked', true);
                break;
            case 'hidden':
                input = $(`<input type="hidden">`);
                if (field.value) input.val(field.value);
                break;
            case 'info':
                input = $(`<div class="${field.class}"></div>`); // Adds a border and padding
                if (field.html) input.html(field.html);
                break;
            default:
                input = $(`<input type="${field.type}" class="form-control">`);
                if (field.placeholder) input.attr('placeholder', field.placeholder);
                if (field.value) input.val(field.value);
                break;
        }
        input.attr('name', `${this.baseName}[${rowIndex}][${field.name}]`);
        input.attr('id', `${this.baseName}[${rowIndex}][${field.name}]`);

        if (field.hasOwnProperty('class')) {
            input.attr('class', `${field.class}`);
        }

        input.on('change', () => this.validateField(input));

        input.on('blur', () => this.validateField(input));

        return input;
    }

    setupFieldDependencies() {
        const self = this;
        this.container.on('change', '[data-dependent-field]', function() {
            const controllerName = $(this).data('dependent-field');
            const controllerValue = $(this).val();
            const dependentValue = $(this).data('dependent-value');

            self.container.find(`[name$="[${controllerName}]"]`).each(function() {
                if ($(this).val() === dependentValue) {
                    $(this).closest('.form-group').show();
                } else {
                    $(this).closest('.form-group').hide();
                }
            });
        });
    }

    updateRemoveButtonsVisibility() {
        const rowCount = this.container.find('.additional-row-item').length;
        this.container.find('.additional-row-item').each((index, element) => {
            // Note the use of arrow function here to preserve `this` context
            if (!this.globalConfig.enforceFirstEntry || rowCount > 1 || index > 0) {
                $(element).find('.removeRow').show();
            } else {
                $(element).find('.removeRow').hide();
            }
        });
    }

    updateAddRowButtonVisibility() {
        const currentRowCount = this.container.find('.additional-row-item').length;
        if (this.globalConfig.maxItems && currentRowCount >= this.globalConfig.maxItems) {
            this.container.find('.addRow').hide();
        } else {
            this.container.find('.addRow').show();
        }
    }

    addRow(rowData = null) {
        const currentRowCount = this.container.find('.additional-row-item').length;

        if (this.globalConfig.maxItems && currentRowCount >= this.globalConfig.maxItems) {
            console.log("Max items limit reached.");
            return;
        }

        let rowIndex = this.rowCount++;
        const enforceFirstEntry = this.globalConfig.hasOwnProperty('enforceFirstEntry') && this.globalConfig.enforceFirstEntry === true;


        let rowWrapper = $('<div class="mb-3 p-3 additional-row-item" style="border: 1px solid #ccc; border-radius: 5px;"></div>');
        let row = $('<div class="row"></div>');

        // Move the removeButton to the top-right of the row
        let removeButtonCol = $('<div class="col-12 text-end"></div>');
        let removeButton = $('<button tabindex="-1" type="button" class="btn btn-danger removeRow mb-2"><i class="fa fa-minus-circle"></i></button>');

        if (!enforceFirstEntry || currentRowCount > 0) {
            removeButtonCol.append(removeButton);
            row.append(removeButtonCol);
        }

        this.fieldConfigs.forEach(field =>
        {
            if (field.type === 'hidden') return;

            let colSizeClasses = typeof field.colSize === 'object'
                ? Object.entries(field.colSize).map(([breakpoint, size]) => `col-${breakpoint}-${size}`).join(' ')
                : field.colSize ? `col-${field.colSize}` : 'col';
            let col = $(`<div class="${colSizeClasses}"></div>`);

            // Wrap input in a div with specified classes
            let inputGroup = $('<div class="form-group mb-3 is-invalid"></div>');

            let label;

            if (field.label) {
                let labelWithIndex = field.label.replace('###ROW_INDEX###', rowIndex + 1);
                label = $(`<label class="form-label">${labelWithIndex}</label>`);
                inputGroup.append(label); // Append label to the inputGroup for proper grouping
            }

            let input = this.createInput(field, rowIndex);
            if (rowData && rowData.hasOwnProperty(field.name)) {
                input.val(rowData[field.name]);
            }

            inputGroup.append(input); // Append input to the inputGroup

            if (field.type === 'checkbox') {
                let wrapper = $('<div class="form-check"></div>');
                wrapper.append(input);
                if (field.label) {
                    let checkboxLabel = $(`<label class="form-check-label" for="">${field.checkboxLabel}</label>`);
                    label.attr('for', `${this.baseName}[${rowIndex}][${field.name}]`);

                    wrapper.append(checkboxLabel);
                }
                inputGroup.append(wrapper); // Wrap the checkbox with the form-check wrapper
            }

            col.append(inputGroup); // Append the inputGroup to the column
            row.append(col);
        });

        rowWrapper.append(row);

        // After appending visible fields to row and row to rowWrapper
        this.fieldConfigs.forEach(field => {
            if (field.type === 'hidden') {
                let input = this.createInput(field, rowIndex);
                if (rowData && rowData.hasOwnProperty(field.name)) {
                    input.val(rowData[field.name]);
                }
                rowWrapper.append(input);
            }
        });

        let tempId = this.generateSecureTempId();
        let tempIdInput = this.createInput({type: 'hidden', 'name': 'temp_id'}, rowIndex);
        tempIdInput.val(tempId);

        rowWrapper.addClass('tid_'+tempId);

        rowWrapper.append(tempIdInput);

        this.container.append(rowWrapper);

        if (this.globalConfig.hasOwnProperty('onRowAdded') && typeof this.globalConfig.onRowAdded === 'function') {
            this.globalConfig.onRowAdded(rowWrapper);
        }

        if (this.globalConfig.hasOwnProperty('onRowRemoved') && typeof this.globalConfig.onRowRemoved === 'function') {
            this.globalConfig.onRowRemoved(rowWrapper);
        }

        this.processDependenciesForRow(rowIndex);
        this.triggerDependencyCheckForRow();
        this.updateAddRowButtonVisibility();
        this.triggerAllDependencyChecks();
    }

    generateSecureTempId()
    {
        const randomValues = window.crypto.getRandomValues(new Uint8Array(16));
        return Array.from(randomValues).map(b => b.toString(16).padStart(2, '0')).join('');
    }

    removeRow(event) {
        $(event.target).closest('.additional-row-item').remove();
        this.reindexRows();
        this.updateRemoveButtonsVisibility();
        this.updateAddRowButtonVisibility();
        this.triggerAllDependencyChecks();
    }

    reindexRows() {
        this.rowCount = 0;
        this.container.find('.additional-row-item').each((index, row) => {
            $(row).find('input, select').each((_, input) => {
                let originalName = $(input).attr('name');
                let newName = originalName.replace(/\[\d+\]/, `[${index}]`); // Update the index in the name
                $(input).attr('name', newName);
            });
            this.rowCount++;
        });
        // After reindexing, re-setup dependencies for all rows
        this.container.find('.additional-row-item').each((index, _) => this.processDependenciesForRow(index));
    }

    triggerDependencyCheckForRow(rowIndex) {
        const self = this;
        this.fieldConfigs.forEach(field => {
            if (field.dependency) {
                const controllerName = `${self.baseName}[${rowIndex}][${field.dependency.controller}]`;
                self.container.find(`[name="${controllerName}"]`).trigger('change');
            }
        });
    }

    processDependenciesForRow(rowIndex) {
        // Iterate over each field configuration
        this.fieldConfigs.forEach((field) => {
            if (field.dependency) {
                // Construct the name attribute for the controller field
                const controllerName = `${this.baseName}[${rowIndex}][${field.dependency.controller}]`;
                const controllerInput = this.container.find(`[name="${controllerName}"]`);

                // Remove any previously attached 'dependency' namespaced event listeners
                // to prevent duplication before attaching a new one
                controllerInput.off('change.dependency');

                // Reattach the event listener with the 'dependency' namespace
                controllerInput.on('change.dependency', () => {
                    // For each dependent field, check if it should be shown or hidden based on the current value of the controller
                    this.fieldConfigs.forEach((innerField) => {
                        if (innerField.dependency && innerField.dependency.controller === field.dependency.controller) {
                            const dependentFieldName = `${this.baseName}[${rowIndex}][${innerField.name}]`;
                            const dependentInput = this.container.find(`[name="${dependentFieldName}"]`);
                            const shouldBeVisible = controllerInput.val() === innerField.dependency.value;

                            dependentInput.closest('.form-group').toggle(shouldBeVisible);
                        }
                    });
                });

                // Immediately trigger the change event to apply the correct visibility state
                // based on the current value of the controller field
                controllerInput.trigger('change.dependency');
            }
        });
    }

    triggerAllDependencyChecks() {
        this.container.find('.row').each((index, _) => {
            const rowIndex = index; // Obtain the correct row index if necessary
            this.fieldConfigs.forEach(field => {
                if (field.dependency) {
                    const controllerName = `${this.baseName}[${rowIndex}][${field.dependency.controller}]`;
                    this.container.find(`[name="${controllerName}"]`).trigger('change');
                }
            });
        });
    }
}


window.DynamicFormRows = DynamicFormRows;
